import timg1 from '../images/team/Migue.png'
import timg2 from '../images/team/Nathalie.png'
import timg3 from '../images/team/José.png'
import timg4 from '../images/team/Juliana.png'
import timg5 from '../images/team/Angie.png'


const Teams = [
    {
       id:'1',
       tImg:timg1,
       name:'Miguel Ariza',
       title:'Abogado',     
    },
    {
       id:'2',
       tImg:timg2,
       name:'Nathalie Torres',
       title:'Psic\u00f3loga',     
    },
    {
       id:'3',
       tImg:timg3,
       name:'Jos\u00e9 Guzm\u00e1n',
       title:'Comunicador Social',     
    },
    {
       id:'4',
       tImg:timg4,
       name:'Juliana Tapia',
       title:'Psic\u00f3loga',     
    },
    {
       id:'5',
       tImg:timg5,
       name:'Angie Hinestroza',
       title:'Abogada',     
    }
]

export default Teams;